export { default as UserPreferencePage } from './UserPreferencePage';
export * from './perspective';
export * from './namespace';
export * from './language';
